import { UserResponse } from "../../model/userResponse";
import { fetchGetJSON } from "../api-helpers";
import { apiUrls } from "../constants";

type DtoType = UserResponse;

type fetchResponseType = {
  data?: DtoType[];
  error?: string;
};

export type GuiResponseType = {
  data?: DtoType[];
  error?: string;
};

export async function getUsersUnassigned(): Promise<GuiResponseType> {
  try {
    const response: fetchResponseType = await fetchGetJSON(
      apiUrls.getUsersUnassigned
    );
    if (response.error) {
      return { error: response.error };
    } else if (response.data) {
      return { data: response.data };
    }
    return { error: "invariant violation" };
  } catch (err) {
    console.error("Error API: getUsersUnassigned:", err);
    return { error: (err as Error).message };
  }
}
